export const ElementsConfig = {
    diabetesConfig: {
        type: 'dropdown',
        options: [
            { value: 'Male', code: 'M' },
            { value: 'Female', code: 'F' }
        ],
        defaultValue: null,
        name: 'diabetes',
        label: 'Is your Diabetes?',
        errorMessage: 'Please select',
        readonly: false,
        controlName: 'diabetes',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    buttonConfig: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Next',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    }
};
